import React from "react";
import {Box, Button, Flex, Grid, Text} from "@chakra-ui/react";
import {APP_LOCALE} from "../utils/appLocale";

const dateToString = (date) => {
  return date.toISOString().slice(0, 10);
};

export {dateToString};

export default function DateStrip({
  activeDate,
  onDateSelect,
  completedDates = [],
  onGoToToday,
}) {
  const todayStr = dateToString(new Date());
  const selectedStr = dateToString(activeDate || new Date());
  const isViewingToday = selectedStr === todayStr;

  const dateCenter = new Date(activeDate || new Date());
  const monthLabel = dateCenter.toLocaleDateString(APP_LOCALE, {
    month: "long",
    year: "numeric",
  });

  const dateDays = [];
  for (let i = -10; i <= 10; i++) {
    const d = new Date(dateCenter);
    d.setDate(dateCenter.getDate() + i);
    dateDays.push(d);
  }

  return (
    <Box
      px={3}
      py={3}
      mb={5}
    >
      <Flex align="center" justify="space-between" mb={2} px={1}>
        <Text fontSize="xs" fontWeight="500" color="gray.500">
          {monthLabel}
        </Text>
        {!isViewingToday && (
          <Button
            size="xs"
            variant="ghost"
            color="#5754FF"
            fontWeight="500"
            _hover={{bg: "#f0f0ff"}}
            onClick={onGoToToday}
          >
            Back to today
          </Button>
        )}
      </Flex>
      <Grid
        templateColumns={`repeat(${dateDays.length}, 1fr)`}
        gap={0}
        w="100%"
      >
        {dateDays.map((d) => {
          const dStr = dateToString(d);
          const isSelected = dStr === selectedStr;
          const isToday = dStr === todayStr;
          const isCompleted = completedDates?.includes?.(dStr);
          const isFuture = d > new Date();
          const dayLabel = d.toLocaleDateString(APP_LOCALE, {weekday: "narrow"});
          return (
            <Box
              key={dStr}
              as="button"
              disabled={isFuture}
              onClick={() => {
                if (isFuture) return;
                onDateSelect(d, dStr);
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              py={1.5}
              rounded="md"
              bg={isSelected ? "#5754FF" : "transparent"}
              color={isSelected ? "white" : isFuture ? "gray.300" : "gray.600"}
              cursor={isFuture ? "not-allowed" : "pointer"}
              transition="all 0.15s"
              _hover={!isFuture && !isSelected ? {bg: "gray.50"} : {}}
              position="relative"
            >
              <Text fontSize="10px" fontWeight="500" opacity={0.6} mb={0.5}>
                {dayLabel}
              </Text>
              <Text
                fontSize="sm"
                fontWeight={isSelected ? "600" : isToday ? "600" : "400"}
                color={isSelected ? "white" : isToday ? "#5754FF" : isFuture ? "gray.300" : "gray.700"}
              >
                {d.getDate()}
              </Text>
              <Box h="6px" display="flex" alignItems="center" justifyContent="center">
                {isCompleted && (
                  <Box
                    w="4px"
                    h="4px"
                    bg={isSelected ? "white" : "green.400"}
                    borderRadius="full"
                  />
                )}
              </Box>
            </Box>
          );
        })}
      </Grid>
    </Box>
  );
}
